export enum WikiTypes {
    custom = 'cust',
    app = 'app'
};

export const ALLOWED_LANGS = ['cs', 'en'];
export const DEFAULT_IDE_LANG = 'cs';

export type TreeItem = {
    type: string | 'page' | 'file';
    id: number;
    name: string;
    lang: string;
    main_page: boolean;
    sidebar: boolean;
    folder?: boolean;
};

/** GET wiki/vectors — state of the semantic-search index of one wiki (WikiVectorService::getStatus) */
export type VectorStatus = {
    /** the vector API is set up on the server (only the flag is exposed, never the URL, model or key) */
    configured: boolean;
    /** a saved page is vectorized right away — the application documentation only, a customer's wiki is indexed by the reindex alone */
    indexOnSave: boolean;
    accounting: number;
    pages?: number;
    indexed?: number;
    chunks?: number;
    stale?: number;
    /** a failed status query, typically the WIKI_VECTOR table not deployed yet */
    error?: string;
};

/** POST wiki/vectors/reindex — result of one run (WikiVectorService::reindex) */
export type VectorReindexResult = {
    pages: number;
    indexed: number;
    chunks: number;
    deleted: number;
    failed: { idz: number; name: string; error: string }[];
    /** the error that stopped the run when the vector API turned out to be down, otherwise null */
    aborted: string | null;
    remaining: number;
};
